import { DateFormat, getKeyFromObj } from "../../../config/helper";
import { TAB_KEYS } from "./user-management";

export const USER_TABLE = [
  {
    id: "name",
    headerKey: "USER_MANAGEMENT.LIST.NAME",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Active, TAB_KEYS.Inactive],
  },
  {
    id: "username",
    headerKey: "USER_MANAGEMENT.LIST.USERNAME",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "username",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Active, TAB_KEYS.Inactive],
  },
  {
    id: "email",
    headerKey: "USER_MANAGEMENT.LIST.EMAIL",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "email",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Active, TAB_KEYS.Inactive],
  },
  {
    id: "created_date",
    headerKey: "USER_MANAGEMENT.LIST.CREATED_DATE",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "created_date",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Active],
  },
  {
    id: "created_by",
    headerKey: "USER_MANAGEMENT.LIST.CREATED_BY",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "created_by_user.name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Active],
  },
  {
    id: "inactive_by",
    headerKey: "USER_MANAGEMENT.LIST.INACTIVE_BY",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "updated_by_user.name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Inactive],
  },
  {
    id: "inactive_date",
    headerKey: "USER_MANAGEMENT.LIST.INACTIVE_DATE",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "updated_date",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.Inactive],
  },
  {
    id: "actions",
    headerKey: "USER_MANAGEMENT.LIST.ACTIONS",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: null,
    dataValue: function (user, handleDeleteClick, handleEditClick) {
      return getDataValue(
        user,
        this.apiKey,
        this,
        handleDeleteClick,
        handleEditClick
      );
    },
    isForTab: [TAB_KEYS.Active],
  },
];

const DATE_FIELD_API_KEYS = ["created_date", "updated_date"];

function getHeaderValue(t, key) {
  return t(key);
}

function getDataValue(user, key, item, handleDeleteClick, handleEditClick) {
  if (item && ["actions"].includes(item.id)) {
    return (
      <ul className="action-btn">
        <li>
          <a
            href="#!"
            className="btn btn-default"
            onClick={() => handleEditClick(user)}
          >
            <i className="ic-edit"></i>
          </a>
        </li>
        <li>
          <a
            href="#!"
            className="btn btn-default"
            onClick={() => handleDeleteClick(user)}
          >
            <i className="ic-delete"></i>
          </a>
        </li>
      </ul>
    );
  }
  if (DATE_FIELD_API_KEYS.includes(key)) {
    return DateFormat(new Date(user[key]));
  }
  return getKeyFromObj(user, key, "-");
}
